import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import App from './App';
import theme from './style/palette';
import { AuthProvider } from './contexts/AuthContext';
import { initUmami, installAttributionHeader } from './utils/umami';

installAttributionHeader(axios);

const root = ReactDOM.createRoot(document.getElementById('root'));

(async () => {
  let isAuthenticated = false;
  let userData = null;

  try {
    const response = await axios.get('/api/users/me', {
      withCredentials: true,
    });
    if (response.status === 200) {
      isAuthenticated = true;
      userData = response.data;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Login warning', error.message);
  } finally {
    document.getElementById('cil-loader').style.display = 'none';
    // Dopo /users/me: i dispositivi dello staff vanno esclusi prima del primo pageview
    initUmami(userData);

    root.render(
      <BrowserRouter>
        <ChakraProvider theme={theme} portalZIndex={100002}>
          <AuthProvider
            initialIsAuthenticated={isAuthenticated}
            initialUserData={userData}
          >
            <App />
          </AuthProvider>
        </ChakraProvider>
      </BrowserRouter>
    );
  }
})();
